import * as React from 'react'
import Img from 'gatsby-image'
import { Container } from '../styles'
import { Flex } from 'grid-styled'
import { Customer, Content, AfterContent } from './styles'

interface IProps {
  image: object
}

export const WebCases: React.SFC<IProps> = ({ image }) => (
  <Container id="web">
    <Flex mt={5} justifyContent="center">
      <h1>Web Development Success Stories</h1>
    </Flex>
    <Customer>
      <Content color="#EF2D56">
        <a href="https://brisbanewhalewatching.com.au">
          <img
            src="http://theinflatablefactory.com.au/images/logo-load-dark.png"
            width="144"
            height="46"
            alt="Inflatable factory logo"
          />
        </a>
        <p>
          The Inflatable Factory was looking to create a brand new moving fun
          park in the greater brisbane region. They needed a brand and website
          that could excite and inspire. We created their brand and web presence
          from scratch with a fun and lighthearted image.
        </p>
      </Content>
      <Img fluid={image} />
    </Customer>
    <AfterContent>
      <div>
        <a target="_blank" href="http://brisbanewhalewatching.com.au">
          <svg
            version="1"
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 834 1000"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#1947a7"
              d="M112 972l71-241c14-46 24-93 39-139 21-64 5-118-37-169-36-45-72-91-104-139-39-61-55-128-27-198 8-22 28-40 49-58-21 77 33 114 74 154 40 38 85 70 129 103 34 25 59 53 57 100 47-14 95-6 141 5 47 11 94 22 142 25 58 4 108-13 163-27-27 58-55 117-118 150-72 38-150 48-230 45-51-2-64 8-51 57 19 71 46 139 71 208 7 23 17 44 25 62-135-9-278 28-394 62z"
            />
          </svg>
        </a>
        <p>
          Brisbane Whale Watching came to us to help redesign and rebuild their
          website. Since the redesign we've seen a 2x improvement in conversion
          rate, and a 16% increase in average order value.
        </p>
      </div>
      <div>
        <a target="_blank" href="https://www.diversegroup.net">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/bc/Rebel_sport_logo_2012.png"
            width="64"
            height="46"
            alt="Rebel logo"
          />
        </a>
        <p>
          A partner of rebel sports approached us in search of an online
          application that could power Rebel Sport & Amart's equipment and
          delivery systems across Australia. We designed and developed a web
          application from the ground up to create a 7x improvement in
          efficiency and 85% decrease in paperwork.
        </p>
      </div>
      <div>
        <a target="_blank" href="https://crest.com.au">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="50"
            viewBox="0 0 343.887 116.255"
          >
            <path d="M220.91 94.453v-.006M49.143 99.76c-2.03.626-4.23.957-6.61.957-4.183 0-7.74-.873-10.675-2.628-2.94-1.75-5.338-4.04-7.2-6.86-1.864-2.83-3.22-6.04-4.07-9.66-.843-3.62-1.265-7.23-1.265-10.84 0-6.67.78-12.06 2.367-16.19 1.582-4.12 3.56-7.34 5.93-9.65 2.373-2.32 4.973-3.91 7.79-4.75 2.827-.85 5.48-1.28 7.966-1.28 5.422 0 9.912 1.38 13.472 4.15l.016.01.012-.05c3.8 2.81 6.72 6.8 8.293 11.43 3.35-1.63 10.72-5.2 15.85-7.71-.64-1.97-1.44-3.79-2.4-5.48-2.27-3.956-5.17-7.23-8.73-9.827-3.56-2.595-7.62-4.543-12.2-5.85-4.58-1.29-9.4-1.94-14.48-1.94-7.24 0-13.54 1.21-18.9 3.636-5.37 2.44-9.86 5.77-13.47 10-3.62 4.24-6.33 9.24-8.14 15C.91 58.027 0 64.18 0 70.73c0 6.437.94 12.424 2.803 17.956 1.86 5.538 4.602 10.31 8.215 14.317 3.613 4.012 8.045 7.176 13.3 9.487 5.253 2.317 11.32 3.477 18.214 3.477 11.29 0 20.354-3.024 27.19-9.068 5.064-4.48 8.72-10.34 11.023-17.76-2.176-1.05-10.574-5.12-14.846-7.19-1.87 8.71-8.4 15.6-16.76 17.81zm97.413-73.077c-15.06-6.653-59.314-5.286-59.314 45.66v41.538h19.312l.004-36.62-.004-12.71c.107-3.27.764-6.32 1.95-9.14 1.185-2.82 2.765-4.95 4.74-7.04 1.978-2.09 4.347-4.05 7.118-5.23 2.764-1.18 5.846-1.77 9.232-1.77 1.438 0 2.932.17 4.307.44 1.78-3.23 3.86-6.24 6.23-8.96 1.95-2.25 4.11-4.29 6.43-6.13zm14.7 48.385l56.8.016c.783-6.552.36-12.903-1.27-19.063-1.643-6.15-4.266-11.6-7.88-16.34-3.616-4.74-8.16-8.55-13.642-11.43-5.48-2.88-11.662-4.32-18.555-4.32-3.5 0-6.79.37-9.9 1.08-2.27.52-4.43 1.22-6.49 2.11-.41.18-.83.35-1.23.54-5.2 2.48-9.64 5.85-13.31 10.08-2.73 3.14-4.98 6.65-6.77 10.53-.63 1.36-1.2 2.76-1.71 4.21-1.98 5.6-2.97 11.5-2.97 17.71 0 6.78.93 12.99 2.8 18.64 1.86 5.65 4.63 10.51 8.3 14.57 1.82 2.02 3.85 3.82 6.08 5.4 2.25 1.597 4.72 2.96 7.39 4.097 5.31 2.26 11.41 3.394 18.3 3.394 4.74 0 9.29-.656 13.64-1.952 4.34-1.29 8.27-3.22 11.77-5.76 3.5-2.542 6.49-5.674 8.98-9.4 1.06-1.59 1.99-3.28 2.78-5.06l-14.73-7.12c-1.85 4.22-4.86 7.78-8.62 10.25-2.156 1.42-4.553 2.47-7.117 3.09-1.21.27-2.495.46-3.85.57-.926.077-1.87.13-2.86.13-4.07 0-7.57-.7-10.51-2.113-.314-.15-.603-.332-.91-.5-2.52-1.352-4.66-3.064-6.373-5.18-1.92-2.37-3.275-5.165-4.32-8.3-2.354-7.093-3.43-22.99.51-31.69 1.26-2.792 2.763-5.273 4.743-7.37 1.98-2.09 4.35-3.73 7.116-4.912 2.505-1.07 5.274-1.63 8.29-1.73.312-.01.62-.04.94-.04 3.28 0 6.24.65 8.893 1.955 2.656 1.296 4.916 2.99 6.777 5.077 1.86 2.09 3.336 4.555 4.408 7.37.862 2.285 1.44 4.64 1.76 7.067H161.6c-.83 4.31-.847 9.77-.37 14.438zm134.932 1.876c-1.643-2.937-3.795-5.365-6.455-7.286-2.662-1.918-5.697-3.447-9.098-4.574-3.396-1.13-6.85-2.086-10.357-2.873-3.63-.8-7.14-1.53-10.535-2.2-3.402-.68-6.426-1.49-9.094-2.46-2.67-.96-4.82-2.17-6.46-3.64-1.65-1.46-2.46-3.39-2.46-5.76 0-1.91.56-3.47 1.69-4.66 1.12-1.18 2.51-2.08 4.15-2.71 1.63-.62 3.39-1.04 5.25-1.27 1.86-.22 3.47-.33 4.83-.33 4.28 0 8.1.79 11.43 2.37 0 .01.01.01.02.02l-.02-.03c3.63 1.84 6.71 4.64 8.96 8.06l15.34-7.43c-.56-1.33-1.21-2.58-1.96-3.74-2.2-3.44-4.97-6.24-8.3-8.39-3.34-2.14-7.06-3.7-11.19-4.66-4.12-.95-8.44-1.43-12.96-1.43-3.95 0-8.1.4-12.45 1.19-4.35.79-8.3 2.174-11.86 4.15-3.56 1.977-6.5 4.574-8.81 7.794-2.318 3.218-3.477 7.2-3.477 11.94 0 4.41.79 8.11 2.37 11.1 1.58 2.996 3.695 5.45 6.35 7.37s5.645 3.448 8.98 4.57c3.33 1.13 6.81 2.09 10.42 2.88 3.5.798 6.95 1.53 10.335 2.21 3.382.676 6.4 1.497 9.06 2.455 2.65.962 4.82 2.23 6.52 3.813 1.684 1.58 2.59 3.61 2.705 6.095.11 2.484-.48 4.49-1.78 6.016-1.3 1.52-2.96 2.685-5 3.47-2.03.794-4.21 1.33-6.52 1.614-2.31.28-4.38.42-6.184.42-.526 0-1.04-.02-1.554-.04-4.534-.204-8.48-1.31-11.827-3.34-3.98-2.49-7.167-6.27-9.08-10.68-4.46 2.145-13.347 6.08-15.54 7.14.5 1.77 1.2 3.608 2.01 5.146 1.973 3.78 4.69 6.95 8.15 9.485 3.45 2.54 7.52 4.436 12.22 5.68 4.7 1.236 9.817 1.865 15.37 1.865 4.52 0 9.105-.51 13.75-1.53 4.64-1.02 8.857-2.65 12.646-4.92 3.79-2.26 6.88-5.192 9.25-8.81 2.38-3.61 3.57-8.014 3.57-13.21 0-4.29-.82-7.905-2.47-10.844zm31.766 35.916c-5.307-2.254-9.8-5.42-13.47-9.486-3.67-4.068-6.437-8.92-8.302-14.572-1.832-5.555-2.758-11.658-2.787-18.31l-.004-.004V.026h19.31v26.262h21.66v14.404H322.7v30.812h.002c0 3.386.48 6.666 1.44 9.83.958 3.16 2.397 5.928 4.32 8.3 1.92 2.37 4.347 4.263 7.284 5.674 2.47 1.19 5.334 1.874 8.605 2.068l.01 18.846c-6.12-.192-11.58-1.31-16.4-3.36z" />
          </svg>
        </a>
        <p>
          One of Australia's leading electronics suppliers, we helped Crest give
          their website a makeover. A compelete rebrand and rebuild allowed
          their business to be proud of their corporate presence and attract new
          overseas clients. The entire system was designed to be simple and easy
          to use, so that any staff member could update the website as needed.
        </p>
      </div>
    </AfterContent>
  </Container>
)
